module.exports = __webpack_public_path__ + "static/media/pop_wechat_qrcode@2x.6fc21a3e.png";